export default "__VITE_ASSET__9e65ce20__"